import { Route, Routes } from 'react-router-dom';
import './index.css';
import './App.css';
import Header from './Header';

// Pages
import Home from './Home';
import Projects from './Projects';
import Project from './Project';
import About from './About';
import Resume from './Resume';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/project" element={<Project />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
      </Routes>
    </>
  );
}

export default App;
